import {
	CLIENT_RENEG_LIMIT
} from 'tls';




const login = () => import('@/components/login');
const index = () => import('@/components/index');
const News = () => import('@/components/News');
const Corporate = () => import('@/components/Corporate');
const Message = () => import('@/components/Message');
const support = () => import('@/components/support');
const newMechanism = () => import('@/components/newMechanism');
const wellness = () => import('@/components/wellness');
const MedicalReproductive = () => import('@/components/MedicalReproductive');
const about = () => import('@/components/about');
const Newsdetails = () => import('@/components/Newsdetails');
const channels = () => import('@/components/channels');






const routes = [
	{
		path: '/',
		name: 'login',
		component: login,
		meta: {
			// 页面标题title
			// title: '登录',
		}
	},
	{
		path: '/index',
		name: 'index',
		component: index,
	},

  {
  	path: '/News',
  	name: 'News',
  	component: News,
  },
  {
  	path: '/Corporate',
  	name: 'Corporate',
  	component: Corporate,
  },
  {
  	path: '/Message',
  	name: 'Message',
  	component: Message,
  },
  {
  	path: '/support',
  	name: 'support',
  	component: support,
  },
  {
  	path: '/newMechanism',
  	name: 'newMechanism',
  	component: newMechanism,
  },
  {
  	path: '/wellness',
  	name: 'wellness',
  	component: wellness,
  },
  {
  	path: '/MedicalReproductive',
  	name: 'MedicalReproductive',
  	component: MedicalReproductive,
  },
  {
  	path: '/about',
  	name: 'about',
  	component: about,
  },
  {
  	path: '/Newsdetails',
  	name: 'Newsdetails',
  	component: Newsdetails,
  },
  {
  	path: '/channels',
  	name: 'channels',
  	component: channels,
  },
 




];

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js